import * as React from "react";
import { images } from "./assets/images";
import SearchBar from "../../../../common/search_field/search_field";

interface HeroSectionProps {
  searchText: string;
  setSearchText: (val: string) => void;
  selectedCity: string;
  setSelectedCity: (val: string) => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  searchText,
  setSearchText,
  selectedCity,
  setSelectedCity,
}) => {
  return (
    <div className="w-screen h-screen relative overflow-hidden">
      <img
        src={images.backgroundHero}
        className="w-full h-full object-cover"
        alt="Hero background"
      />
      <img
        src={images.cloud}
        className="absolute bottom-[0%] sm:bottom-[10%] md:bottom-[10%] lg:bottom-[-50%] xl:bottom-[-50%] left-0 z-10 w-auto h-auto"
        alt="Cloud decoration"
      />
      <div className="absolute top-1/4 sm:top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-40 w-full px-4 sm:px-8 md:px-12 lg:px-0 max-w-xs sm:max-w-sm md:max-w-2xl lg:max-w-3xl">
        <SearchBar
          searchText={searchText}
          setSearchText={setSearchText}
          selectedCity={selectedCity}
          setSelectedCity={setSelectedCity}
        />
      </div>
      <div className="absolute w-full z-1 text-primary font-bold bottom-0 flex flex-col items-center justify-center gap-4 mb-12 sm:mb-18 md:mb-20 lg:mb-32 z-20">
        <div className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-ubuntu font-bold text-center px-4">
          Explore the World from Above
        </div>
        <div className="text-lg sm:text-xl md:text-1xl lg:text-1xl font-ubuntu text-center px-4">
          Rent Drones and Capture Stunning Aerial Views
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
